import React from 'react';

interface TimesheetHeaderProps {
    onClose: () => void;
}

export const TimesheetHeader: React.FC<TimesheetHeaderProps> = React.memo(({ onClose }) => (
        <div className="timesheet-modal__header">
            <button
                type="button"
                className="timesheet-modal__close"
                onClick={onClose}
                aria-label="Close modal"
            >
                <i className="icon icon-close" />
            </button>
            <h1>Generate Timesheet</h1>
        </div>
    ));

TimesheetHeader.displayName = 'TimesheetHeader';

